/* global $ */

import DesignApproachSection from './DesignApproachSection';

class PageCulture {
  constructor(mainApp) {
    this.$window = $(window);
    console.log('PageCulture');
    this.mainApp = mainApp;
    this.content = new DesignApproachSection($('.Section--designApproach'));

    this.syncHeightItems = [];

    if ($('.SyncHeight').length) {
      $('.SyncHeight').each((i, el) => {
        this.syncHeightItems.push($(el));
      });
    }
  }
  onLoadWindow() {
    $('.Hero-loading').addClass('is-loaded');
  }
  onWindowResize() {
    if (this.syncHeightItems.length) {
      let maxHeight = 0;
      this.syncHeightItems.forEach(($item) => {
        $item.css('height', 'auto');
        if (maxHeight < $item.height()) maxHeight = $item.height();
      });
      $('.SyncHeight').css('height', `${maxHeight}px`);
    }
  }
  onWindowScroll() {}
  destroy() {}
}

export default PageCulture;
